module.exports = __webpack_public_path__ + "img/logo.a13a7a04.svg";